import React from "react";
import Table from "../../components/Table";
import { Column } from "../../components/BaseTable";
import { HuidigeSituatieInkomenOnderneming } from "../../../../.generated/rapportage/rapportagetypes";

export interface InkomensOndernemingTableProps {
  data: HuidigeSituatieInkomenOnderneming[];
}

export const InkomensOndernemingTable: React.FC<InkomensOndernemingTableProps> = ({
  data,
}: InkomensOndernemingTableProps) => {
  return (
    <div>
      {data.map((item, index) => {
        const tableData = item.inkomensPerAanvrager || [];
        const columns: Column[] = [
          {
            header: `${item.omschrijving}`,
            accessor: "naam",
          },
          {
            header: "(Gemiddelde) inkomsten afgelopen 3 jaar",
            accessor: "gemiddeldeInkomsten",
            dataType: "currency",
          },
          {
            header: "Inkomen wordt meegenomen tot",
            accessor: "inkomenMeegenomenTot",
            dataType: "date",
          },
        ];

        return (
          <Table
            key={`inkomens-onderneming-table-${index}`}
            columns={columns}
            data={tableData}
            rotate={true}
            showHeader={true}
            filterNullAnd0Columns={true}
            id={`inkomens-onderneming-table-${index}`}
            regularStyles={tableData?.length > 1}
          />
        );
      })}
    </div>
  );
};
